import { omitBy } from 'lodash';

export function filterEmpty(
  obj: Record<string, unknown>
): Record<string, unknown> {
  return omitBy(obj, (v) => v == null);
}
